import { connect } from 'react-redux';

import { Link } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';

import { Text, Card, Button } from '@shopify/polaris';

const SubmittedMessage = () => {
  return(
    <Card>
      <Text variant="headingXl" as="h4">Changes Submitted</Text>
      <Text>Your changes have been submitted. Click the View Results button to see the results of these changes.</Text>
      <Link to={`../../update_results${window.location.search}`} relative="path">
        <Button>View Results</Button>
      </Link>
    </Card>
  )
}

const mapStateToProps = state => ({
  bulkInventorySession: state.bulkInventorySessions,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SubmittedMessage);
